import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';

import { eventService, getPage, XApiEventKeys } from 'shared/api/event-service';

import styles from './styles.module.scss';

export const BackButtonRow = () => {
  const location = useLocation();

  const handleXApiEvents = (isRightClick: boolean) => {
    eventService.send(XApiEventKeys.backButtonSelected, undefined, {
      result: {
        url: window.location.href,
        page: getPage(),
        isRightClick,
      },
    });
  };

  const handleClick = () => handleXApiEvents(false);

  const handleContextMenu = () => handleXApiEvents(true);

  return (
    <div className="row">
      <div className="container-fluid">
        <div className={styles.backButtonRow}>
          <Link
            to="/"
            className={styles.backButton}
            onClick={handleClick}
            onContextMenu={handleContextMenu}
            state={{ previousLocationPathname: location.pathname }}
          >
            <span className={styles.backButtonText}>
              <i
                className={clsx('icon-v2-chevron-small-left', styles.icon)}
                aria-hidden
              />
              Back
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};
